export default {
  meta: {
    title: 'Docker1s - 快速稳定的Docker镜像加速服务',
    description: '提供快速、稳定、免费的Docker镜像下载加速服务，支持Docker Hub、gcr.io、k8s.gcr.io等多个镜像仓库，CDN加速网络覆盖全球，10倍速度提升',
    keywords: 'docker,镜像加速,docker加速,容器,kubernetes,docker镜像,容器技术,docker hub,gcr.io,k8s.gcr.io,docker pull,镜像下载,容器镜像,docker registry,镜像仓库,CDN加速,全球加速,免费加速,docker1s,容器部署,微服务,devops,CI/CD,容器化,docker daemon,registry mirror,镜像代理,容器云,云原生,kubernetes镜像,k8s镜像,容器编排,docker compose,dockerfile,容器镜像加速,docker镜像代理,容器镜像缓存,docker网络加速,镜像拉取优化',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: 'Docker1s',
      description: '快速稳定的Docker镜像加速服务，提供免费的容器镜像下载加速',
      url: 'https://docker1s.com',
      applicationCategory: 'DeveloperApplication',
      operatingSystem: 'Linux, macOS, Windows',
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'USD'
      },
      provider: {
        '@type': 'Organization',
        name: 'Docker1s'
      },
      featureList: [
        'Docker镜像加速',
        '全球CDN网络',
        '多镜像仓库支持',
        '免费无限使用',
        'HTTPS安全传输'
      ]
    }
  },
  common: {
    login: '登录',
    register: '注册',
    logout: '退出登录',
    profile: '个人中心',
    settings: '设置',
    language: '语言',
    darkMode: '深色模式',
    lightMode: '浅色模式',
    copy: '复制'
  },
  nav: {
    home: '首页',
    docs: '使用文档',
    status: '服务状态',
    about: '关于我们',
    blog: '博客'
  },
  home: {
    title: '一键加速，重塑你的容器世界',
    subtitle: '我们的AI容器镜像加速平台，简单快捷、告别缓慢，轻松纯净超高速力。',
    quickStart: '立即体验',
    pricing: '查看价格',
    stats: {
      accelerations: '容器镜像加速',
      users: '活跃用户',
      uptime: '服务可用性'
    },
    demo: {
      title: '快速开始',
      subtitle: '只需一行命令，即可享受极速的容器镜像下载体验',
      tabs: {
        config: '加速器配置',
        pull: '镜像拉取',
        k8s: 'K8s部署',
        compose: 'Compose配置'
      }
    },
    features: {
      title: '强大的加速功能',
      subtitle: '用领先的技术改变你的容器世界，你需要的一切功能都在这里',
      items: {
        speed: {
          title: '智能镜像加速',
          desc: '使用我们先进的CDN网络和智能缓存技术，为你的Docker镜像下载提供10倍以上的加速体验，告别漫长等待。'
        },
        global: {
          title: '全球节点覆盖',
          desc: '部署遍布全球的加速节点，就近访问最优线路，无论你身在何处都能享受极速的镜像下载体验。'
        },
        secure: {
          title: '安全可靠保障',
          desc: '支持HTTPS加密传输，完整性校验确保镜像安全，99.9%高可用性保障你的容器部署从不掉链子。'
        },
        free: {
          title: '免费无限使用',
          desc: '完全免费的镜像加速服务，无需注册即可使用，支持Docker Hub、gcr.io、k8s.gcr.io等主流镜像仓库。'
        },
        intelligent: {
          title: '智能缓存优化',
          desc: '采用AI驱动的智能缓存算法，预测和预加载热门镜像，实现毫秒级响应，让镜像下载比本地拷贝还要快。'
        },
        support: {
          title: '24/7 技术支持',
          desc: '提供全天候技术支持服务，专业团队实时监控服务状态，确保任何问题都能得到快速响应和解决。'
        }
      }
    }
  },
  docs: {
    title: '使用文档',
    subtitle: '快速开始使用Docker1s镜像加速服务',
    sections: {
      gettingStarted: '快速开始',
      supportedRegistries: '支持的仓库',
      faq: '常见问题'
    },
    content: {
      gettingStarted: {
        title: '快速开始',
        description: 'Docker1s是一个免费的Docker镜像加速服务，无需注册即可使用。',
        method1: '方法一：配置镜像加速器（推荐）',
        configComment: '创建或修改 /etc/docker/daemon.json',
        restartComment: '重启Docker服务',
        method2: '方法二：直接拉取',
        directPullComment: '直接使用加速域名拉取镜像'
      },
      supportedRegistries: {
        title: '支持的镜像仓库',
        description: 'Docker1s支持以下主流镜像仓库的加速：',
        dockerHub: '官方镜像仓库，包含大量优质镜像',
        gcr: 'Google的容器镜像仓库',
        k8s: 'Kubernetes官方镜像仓库'
      },
      kubernetes: {
        title: '在Kubernetes中使用',
        description: '在Kubernetes集群中使用Docker1s加速镜像拉取。',
        deploymentExample: 'Deployment示例'
      },
      dockerCompose: {
        title: 'Docker Compose',
        description: '在Docker Compose中使用加速镜像。'
      },
      faq: {
        title: '常见问题',
        q1: {
          question: 'Q: Docker1s是否免费？',
          answer: 'A: 是的，Docker1s完全免费，无需注册即可使用。'
        },
        q2: {
          question: 'Q: 加速效果如何？',
          answer: 'A: 根据地理位置和网络条件，通常可以提供3-10倍的下载速度提升。'
        },
        q3: {
          question: 'Q: 是否支持私有镜像？',
          answer: 'A: 目前只支持公开镜像的加速，私有镜像请使用原始仓库地址。'
        },
        q4: {
          question: 'Q: 如何验证配置是否生效？',
          answer: 'A: 运行 docker info 命令，查看 Registry Mirrors 字段是否包含我们的加速地址。'
        }
      }
    }
  },
  status: {
    title: '服务状态',
    subtitle: '实时监控Docker1s镜像加速服务的运行状态',
    allOperational: '所有系统运行正常',
    operational: '正常运行',
    duration: '持续时间',
    sections: {
      serviceStatus: '服务状态',
      performanceMetrics: '性能指标',
      incidentHistory: '事件历史'
    },
    services: {
      dockerHub: {
        name: 'Docker Hub 加速',
        description: '官方镜像仓库加速服务'
      },
      gcr: {
        name: 'gcr.io 加速',
        description: 'Google容器镜像仓库加速'
      },
      k8sGcr: {
        name: 'k8s.gcr.io 加速',
        description: 'Kubernetes镜像仓库加速'
      },
      cdn: {
        name: 'CDN 网络',
        description: '全球内容分发网络'
      },
      quay: {
        name: 'Quay.io 加速',
        description: 'Red Hat Quay镜像仓库加速'
      },
      monitoring: {
        name: '监控系统',
        description: '7x24小时实时服务监控'
      }
    },
    metrics: {
      responseTime: '响应时间',
      uptime: '可用性',
      avgResponseTime: '平均响应时间',
      dailyRequests: '今日请求量',
      globalNodes: '全球节点数',
      systemUptime: '系统可用性'
    },
    changes: {
      responseTime: '↑ 15% 比昨天',
      dailyRequests: '↑ 8.2% 比昨天',
      globalNodes: '↑ 2 新增节点',
      systemUptime: '= 持续稳定'
    },
    incidents: {
      incident1: {
        title: '亚太地区部分节点延迟增加',
        description: '由于上游网络波动，亚太地区部分节点出现延迟增加，现已恢复正常。',
        time: '2 小时前',
        duration: '45分钟'
      },
      incident2: {
        title: '计划维护完成',
        description: '欧洲节点计划维护已完成，服务性能得到进一步优化。',
        time: '1 天前',
        duration: '30分钟'
      },
      incident3: {
        title: '新增东南亚节点',
        description: '在新加坡和印尼新增2个加速节点，进一步提升东南亚地区访问速度。',
        time: '3 天前'
      }
    }
  },
  about: {
    title: '关于Docker1s',
    subtitle: '致力于为全球开发者提供最优质的容器镜像加速服务',
    mission: {
      title: '我们的使命',
      description: 'Docker1s致力于解决全球开发者在使用Docker容器技术时遇到的镜像下载缓慢问题。我们相信，技术应该让开发变得更简单、更高效，而不是成为阻碍。通过我们的全球加速网络，让每一位开发者都能享受到极速的容器镜像下载体验。'
    },
    values: {
      title: '核心价值观',
      performance: {
        title: '极致性能',
        description: '不断优化我们的CDN网络和缓存策略，为用户提供最快的下载速度。'
      },
      security: {
        title: '安全可靠',
        description: '严格的安全措施和高可用架构，确保服务稳定性和数据安全。'
      },
      openness: {
        title: '开放共享',
        description: '坚持开源精神，免费为全球开发者社区提供镜像加速服务。'
      },
      global: {
        title: '全球视野',
        description: '构建覆盖全球的服务网络，为世界各地的开发者提供一致的优质体验。'
      }
    },
    achievements: {
      title: '我们的成就',
      totalPulls: '累计镜像拉取次数',
      activeUsers: '活跃开发者用户',
      globalNodes: '全球加速节点',
      uptime: '服务可用性'
    },
    team: {
      title: '团队介绍',
      description: '我们是一支充满激情的技术团队，拥有丰富的云计算、CDN和容器技术经验。团队成员来自知名互联网公司，深度参与过多个大型分布式系统的设计和优化。',
      expertise: {
        title: '技术专长',
        description: '在CDN、负载均衡、容器技术等领域拥有深厚的技术积累'
      },
      global: {
        title: '全球视野',
        description: '团队成员遍布多个国家和地区，深入了解全球开发者需求'
      },
      innovation: {
        title: '持续创新',
        description: '不断探索新技术，优化服务架构，提升用户体验'
      }
    },
    contact: {
      title: '联系我们',
      support: {
        title: '技术支持',
        description: '如果您在使用过程中遇到任何问题，欢迎联系我们的技术支持团队。'
      },
      join: {
        title: '加入我们',
        description: '我们正在寻找优秀的工程师加入团队，一起构建更好的容器生态。',
        viewJobs: '查看职位'
      }
    }
  },
  auth: {
    login: {
      subtitle: '欢迎回来！请登录您的账户'
    },
    register: {
      subtitle: '创建您的Docker1s账户'
    },
    email: '邮箱地址',
    password: '密码',
    username: '用户名',
    confirmPassword: '确认密码',
    emailPlaceholder: '请输入您的邮箱',
    passwordPlaceholder: '请输入您的密码',
    usernamePlaceholder: '请输入您的用户名',
    passwordMinLength: '请输入密码（至少8位）',
    confirmPasswordPlaceholder: '请再次输入密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    loggingIn: '登录中...',
    registering: '注册中...',
    noAccount: '还没有账户？',
    hasAccount: '已有账户？',
    registerNow: '立即注册',
    loginNow: '立即登录',
    or: '或者',
    githubLogin: '使用 GitHub 登录',
    googleLogin: '使用 Google 登录',
    agreeTerms: '我同意',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    and: '和',
    passwordMismatch: '两次输入的密码不一致',
    registerFailed: '注册失败'
  },
  footer: {
    description: '提供快速、稳定、免费的Docker镜像下载加速服务',
    builtWith: '为Docker社区而构建',
    sections: {
      product: '产品',
      support: '支持',
      company: '公司'
    },
    links: {
      imageAcceleration: '镜像加速',
      apiService: 'API 服务',
      privateDeployment: '私有部署',
      enterprise: '企业版',
      apiDocs: 'API 文档',
      faq: '常见问题',
      contact: '联系我们',
      privacy: '隐私政策'
    }
  }
}
